export const truncateString = (value: string, maxLength: number = 15) => {
    if (value.length > maxLength) {
        return `${value.substring(0, maxLength)}...`;
    }

    return value;
};